"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
function useHolidays(firestore, options, useQueryOptions) {
    const appointmentRef = (0, firestore_2.doc)(firestore, "/parametros/providerapp/variables/holidays");
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "holidays",
        path: "parametros/providerapp/variables/holidays"
    }, []), appointmentRef, options, useQueryOptions);
}
exports.default = useHolidays;
